import React from "react";
import { Link } from "react-router-dom";
import "../CSS/About.css";
import heroBg from "../Assets/bgimage.jpg";
import { FaAngleRight } from "react-icons/fa";
import procedureImg from "../Assets/process-img.png";
import processImg from "../Assets/how-to-start-process.png";

export default function About() {
  const heroStyle = {
    backgroundImage: `url(${heroBg})`,
  };

  return (
    <div className="about-page">
      
      {/* Hero Section */}
      <section className="about-hero-section" style={heroStyle}>
        <div className="about-hero-overlay" />
        <div className="about-hero-inner">
          <div className="about-hero-content">
            <h1 className="about-hero-title">ABOUT US</h1>
            <nav
              className="about-hero-breadcrumb"
              aria-label="Breadcrumb"
              role="navigation"
            >
              <ul>
                <li className="about-crumb-home">
                  <Link to="/">Home</Link>
                </li>
                <li className="about-crumb-sep" aria-hidden="true">
                  <FaAngleRight />
                </li>
                <li className="about-crumb-current" aria-current="page">
                  About Us
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </section>

      {/* Procedure Section */}
      <section className="about-procedure-section">
        <div className="about-procedure-container">
          <h2 className="about-procedure-title">
            Procedure For Apostille Certificate In Mumbai
          </h2>
          <div className="about-procedure-image">
            <img src={procedureImg} alt="Apostille Procedure" />
          </div>
        </div>
      </section>

      {/* Main Content Container */}
      <div className="about-main-container">
        <section className="about-main-content">
          <h2>About Advocate Pandey &amp; Associates</h2>
          <p>
            <strong>Advocate Pandey &amp; Associates</strong> is a specialist legal and
            document services firm focused on{" "}
            <strong>apostille, attestation, and legalization</strong> for clients
            across India and abroad. Led by Advocate Pandey — an experienced lawyer
            and attestation consultant — our team blends legal expertise with
            practical document-handling experience to deliver fast, accurate, and
            fully compliant services.
          </p>

          {/* Start Process Section */}
          <section className="about-start-process-section">
            <div className="about-start-process-container">
              <h2 className="about-start-process-title">
                How to start Process
              </h2>
              <div className="about-start-process-image">
                <img src={processImg} alt="How to start Apostille Process" />
              </div>
            </div>
          </section>

          <h3>What we do</h3>
          <p>
            We help individuals, universities, HR teams and businesses with
            end-to-end document legalization. Our core services include:
          </p>
          <ul className="about-list">
            <li>Document apostille (Hague apostille) for education, personal, and commercial documents</li>
            <li>Consular &amp; embassy attestation for visa, immigration and employment</li>
            <li>Notary services, ministry authentication (MEA), and embassy liaison</li>
            <li>Document verification, translation coordination, and courier/tracking support</li>
          </ul>

          <h3>Why choose Advocate Pandey &amp; Associates</h3>
          <p>
            Clients choose us for our legal background, transparent process, and
            local collection centers. We combine:
          </p>
          <ul className="about-list">
            <li><strong>Legal expertise:</strong> led by Advocate Pandey, who advises on document compliance and case-specific legal questions</li>
            <li><strong>Fast turnarounds:</strong> streamlined workflows with tracked courier and priority processing options</li>
            <li><strong>Nationwide reach:</strong> collection centers and partner offices in Delhi-NCR, Mumbai, Hyderabad, Chennai, Kolkata and Bangalore</li>
            <li><strong>Clear pricing:</strong> no hidden fees, quoted estimates and secure payment options</li>
          </ul>

          <h3>Our team</h3>
          <p>
            Our team includes legal consultants, attestation specialists and trained operations
            staff who handle each case personally. We coordinate directly with ministries and
            embassy contacts so you don't have to — from document pickup to final delivery.
          </p>

          <h3>Industries &amp; clients we serve</h3>
          <p>
            We work with students preparing documents for foreign universities, professionals applying
            for work visas, companies handling corporate compliance, and individuals requiring
            certified documents for immigration, marriage, or overseas employment.
          </p>

          <h3>How to get started</h3>
          <p>
            1. Collect the list of required documents for your country/embassy. <br />
            2. Contact our team with basic details or upload documents online. <br />
            3. We will provide a clear timeline and pick-up/delivery options.
          </p>

          <p className="about-contact-note" style={{ marginTop: 12 }}>
            For a fast quote or to speak with Advocate Pandey, call us at{" "}
            <a href="tel:+916393244687" className="about-phone-link">+91-6393244687</a> or use the{" "}
            <a href="/contact" className="about-contact-link">Contact page</a>. We'll review your documents and
            propose the simplest, most reliable solution.
          </p>
        </section>
      </div>
    </div>
  );
}